import React from "react";
import { Button, Card, Grid, Stack, TextField } from "@mui/material";
import Select from "react-select";

const NotificationFor = [
  { label: "All", value: -1 },
  { label: "LVB", value: 0 },
  { label: "State", value: 1 },
  { label: "City", value: 2 },
  { label: "Chapter", value: 3 }
];

const NotificationForCityUser = [
  { label: "All", value: -1 },
  { label: "City", value: 2 },
  { label: "Chapter", value: 3 }
];

const NotificationStatus = [
  { label: "All", value: 0 },
  { label: "Pending", value: 1 },
  { label: "Completed", value: 2 }
];

const NotificationType = [
  { label: "All", value: -1 },
  { label: "Photo", value: 0 },
  { label: "Audio", value: 1 },
  { label: "Video", value: 2 },
  { label: "Question and Answer", value: 3 }
];

function NotificationFilters({ filtereddata, setFilteredData, loginUser }) {
  const forOptions = loginUser?.u_type === 1 ? NotificationForCityUser : NotificationFor;

  return (
    <Card className="p-20 mb-15">
      <Grid container spacing={2} sx={{ alignItems: "center" }}>
        <Grid item xs={2}>
          <Stack sx={{ my: "5px" }}>
            <label>Notification For</label>
            <Select
              menuPortalTarget={document.body}
              value={forOptions.find((c) => c.value === filtereddata.notificationFor) || null}
              onChange={(e) => setFilteredData({ ...filtereddata, notificationFor: e.value })}
              options={forOptions}
            />
          </Stack>
        </Grid>
        <Grid item xs={2}>
          <Stack>
            <label>Notification Status</label>
            <Select
              menuPortalTarget={document.body}
              value={NotificationStatus.find((c) => c.value === filtereddata.notificationStatus) || null}
              onChange={(e) => setFilteredData({ ...filtereddata, notificationStatus: e.value })}
              options={NotificationStatus}
            />
          </Stack>
        </Grid>
        <Grid item xs={3}>
          <Stack>
            <label>Notification Type</label>
            <Select
              menuPortalTarget={document.body}
              value={NotificationType.find((c) => c.value === filtereddata.notificationType) || null}
              onChange={(e) => setFilteredData({ ...filtereddata, notificationType: e.value })}
              options={NotificationType}
            />
          </Stack>
        </Grid>
        <Grid item xs={4}>
          <Stack spacing={10}>
            <TextField
              style={{ marginTop: "20px" }}
              fullWidth
              autoComplete="off"
              type="text"
              size="small"
              label="Search"
              autoCorrect="off"
              value={filtereddata.search}
              onChange={(e) => setFilteredData({ ...filtereddata, search: e.target.value })}
            />
          </Stack>
        </Grid>
        <Grid
          item
          xs={1}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "end",
            marginTop: "20px"
          }}
        >
          <Button
            onClick={() =>
              setFilteredData({
                notificationFor: -1,
                notificationStatus: 0,
                notificationType: -1,
                search: "",
                startDate: "",
                endDate: ""
              })
            }
            variant="contained"
          >
            Clear
          </Button>
        </Grid>
      </Grid>
    </Card>
  );
}

export default NotificationFilters;
